/* eslint-disable */
// this is an auto generated file. This will be overwritten

export const onCreatePricelist = /* GraphQL */ `
  subscription OnCreatePricelist(
    $filter: ModelSubscriptionPricelistFilterInput
  ) {
    onCreatePricelist(filter: $filter) {
      id
      user {
        id
        username
        tier
        email
        address
        city
        state
        zip
        contactName
        companyName
        phoneNumber
        cellNumber
        idImage
        businessLicense
        priceListInvites
        acceptedInvites
        userGroupID
        createdByUserId
        activeInvoiceID
        activePricelistID
        secondPricelistID
        companyLogo
        companyPath
        primaryColor
        secondaryColor
        searchesRemaining
        priceOffsetType
        priceOffsetValue
        providerOffsetType
        providerOffsetValue
        createdAt
        updatedAt
        themeOptions
        subscriptionActive
        lastPaidDate
        subscriptionTier
        subscriptionTerm
        isProvider
        lastLogin
        pricelistSubscribersId
        userGroupUsersId
        userInventoryId
        __typename
      }
      userId
      validRows
      dataCount
      s3Key
      parentPricelist {
        id
        userId
        validRows
        dataCount
        s3Key
        notes
        filename
        adjustments
        name
        status
        providerId
        createdAt
        updatedAt
        pricelistDerivedPricelistsId
        userPricelistsId
        __typename
      }
      derivedPricelists {
        nextToken
        __typename
      }
      notes
      filename
      adjustments
      name
      parts {
        nextToken
        __typename
      }
      hedges {
        nextToken
        __typename
      }
      status
      searches {
        nextToken
        __typename
      }
      provider {
        id
        username
        tier
        email
        address
        city
        state
        zip
        contactName
        companyName
        phoneNumber
        cellNumber
        idImage
        businessLicense
        priceListInvites
        acceptedInvites
        userGroupID
        createdByUserId
        activeInvoiceID
        activePricelistID
        secondPricelistID
        companyLogo
        companyPath
        primaryColor
        secondaryColor
        searchesRemaining
        priceOffsetType
        priceOffsetValue
        providerOffsetType
        providerOffsetValue
        createdAt
        updatedAt
        themeOptions
        subscriptionActive
        lastPaidDate
        subscriptionTier
        subscriptionTerm
        isProvider
        lastLogin
        pricelistSubscribersId
        userGroupUsersId
        userInventoryId
        __typename
      }
      providerId
      subscribers {
        nextToken
        __typename
      }
      createdAt
      updatedAt
      pricelistDerivedPricelistsId
      userPricelistsId
      __typename
    }
  }
`;
export const onUpdatePricelist = /* GraphQL */ `
  subscription OnUpdatePricelist(
    $filter: ModelSubscriptionPricelistFilterInput
  ) {
    onUpdatePricelist(filter: $filter) {
      id
      user {
        id
        username
        tier
        email
        address
        city
        state
        zip
        contactName
        companyName
        phoneNumber
        cellNumber
        idImage
        businessLicense
        priceListInvites
        acceptedInvites
        userGroupID
        createdByUserId
        activeInvoiceID
        activePricelistID
        secondPricelistID
        companyLogo
        companyPath
        primaryColor
        secondaryColor
        searchesRemaining
        priceOffsetType
        priceOffsetValue
        providerOffsetType
        providerOffsetValue
        createdAt
        updatedAt
        themeOptions
        subscriptionActive
        lastPaidDate
        subscriptionTier
        subscriptionTerm
        isProvider
        lastLogin
        pricelistSubscribersId
        userGroupUsersId
        userInventoryId
        __typename
      }
      userId
      validRows
      dataCount
      s3Key
      parentPricelist {
        id
        userId
        validRows
        dataCount
        s3Key
        notes
        filename
        adjustments
        name
        status
        providerId
        createdAt
        updatedAt
        pricelistDerivedPricelistsId
        userPricelistsId
        __typename
      }
      derivedPricelists {
        nextToken
        __typename
      }
      notes
      filename
      adjustments
      name
      parts {
        nextToken
        __typename
      }
      hedges {
        nextToken
        __typename
      }
      status
      searches {
        nextToken
        __typename
      }
      provider {
        id
        username
        tier
        email
        address
        city
        state
        zip
        contactName
        companyName
        phoneNumber
        cellNumber
        idImage
        businessLicense
        priceListInvites
        acceptedInvites
        userGroupID
        createdByUserId
        activeInvoiceID
        activePricelistID
        secondPricelistID
        companyLogo
        companyPath
        primaryColor
        secondaryColor
        searchesRemaining
        priceOffsetType
        priceOffsetValue
        providerOffsetType
        providerOffsetValue
        createdAt
        updatedAt
        themeOptions
        subscriptionActive
        lastPaidDate
        subscriptionTier
        subscriptionTerm
        isProvider
        lastLogin
        pricelistSubscribersId
        userGroupUsersId
        userInventoryId
        __typename
      }
      providerId
      subscribers {
        nextToken
        __typename
      }
      createdAt
      updatedAt
      pricelistDerivedPricelistsId
      userPricelistsId
      __typename
    }
  }
`;
export const onDeletePricelist = /* GraphQL */ `
  subscription OnDeletePricelist(
    $filter: ModelSubscriptionPricelistFilterInput
  ) {
    onDeletePricelist(filter: $filter) {
      id
      user {
        id
        username
        tier
        email
        address
        city
        state
        zip
        contactName
        companyName
        phoneNumber
        cellNumber
        idImage
        businessLicense
        priceListInvites
        acceptedInvites
        userGroupID
        createdByUserId
        activeInvoiceID
        activePricelistID
        secondPricelistID
        companyLogo
        companyPath
        primaryColor
        secondaryColor
        searchesRemaining
        priceOffsetType
        priceOffsetValue
        providerOffsetType
        providerOffsetValue
        createdAt
        updatedAt
        themeOptions
        subscriptionActive
        lastPaidDate
        subscriptionTier
        subscriptionTerm
        isProvider
        lastLogin
        pricelistSubscribersId
        userGroupUsersId
        userInventoryId
        __typename
      }
      userId
      validRows
      dataCount
      s3Key
      parentPricelist {
        id
        userId
        validRows
        dataCount
        s3Key
        notes
        filename
        adjustments
        name
        status
        providerId
        createdAt
        updatedAt
        pricelistDerivedPricelistsId
        userPricelistsId
        __typename
      }
      derivedPricelists {
        nextToken
        __typename
      }
      notes
      filename
      adjustments
      name
      parts {
        nextToken
        __typename
      }
      hedges {
        nextToken
        __typename
      }
      status
      searches {
        nextToken
        __typename
      }
      provider {
        id
        username
        tier
        email
        address
        city
        state
        zip
        contactName
        companyName
        phoneNumber
        cellNumber
        idImage
        businessLicense
        priceListInvites
        acceptedInvites
        userGroupID
        createdByUserId
        activeInvoiceID
        activePricelistID
        secondPricelistID
        companyLogo
        companyPath
        primaryColor
        secondaryColor
        searchesRemaining
        priceOffsetType
        priceOffsetValue
        providerOffsetType
        providerOffsetValue
        createdAt
        updatedAt
        themeOptions
        subscriptionActive
        lastPaidDate
        subscriptionTier
        subscriptionTerm
        isProvider
        lastLogin
        pricelistSubscribersId
        userGroupUsersId
        userInventoryId
        __typename
      }
      providerId
      subscribers {
        nextToken
        __typename
      }
      createdAt
      updatedAt
      pricelistDerivedPricelistsId
      userPricelistsId
      __typename
    }
  }
`;
export const onCreateSecondPricelist = /* GraphQL */ `
  subscription OnCreateSecondPricelist(
    $filter: ModelSubscriptionSecondPricelistFilterInput
  ) {
    onCreateSecondPricelist(filter: $filter) {
      id
      user {
        id
        username
        tier
        email
        address
        city
        state
        zip
        contactName
        companyName
        phoneNumber
        cellNumber
        idImage
        businessLicense
        priceListInvites
        acceptedInvites
        userGroupID
        createdByUserId
        activeInvoiceID
        activePricelistID
        secondPricelistID
        companyLogo
        companyPath
        primaryColor
        secondaryColor
        searchesRemaining
        priceOffsetType
        priceOffsetValue
        providerOffsetType
        providerOffsetValue
        createdAt
        updatedAt
        themeOptions
        subscriptionActive
        lastPaidDate
        subscriptionTier
        subscriptionTerm
        isProvider
        lastLogin
        pricelistSubscribersId
        userGroupUsersId
        userInventoryId
        __typename
      }
      userId
      validRows
      dataCount
      s3Key
      notes
      filename
      adjustments
      name
      parts {
        nextToken
        __typename
      }
      status
      createdAt
      updatedAt
      __typename
    }
  }
`;
export const onUpdateSecondPricelist = /* GraphQL */ `
  subscription OnUpdateSecondPricelist(
    $filter: ModelSubscriptionSecondPricelistFilterInput
  ) {
    onUpdateSecondPricelist(filter: $filter) {
      id
      user {
        id
        username
        tier
        email
        address
        city
        state
        zip
        contactName
        companyName
        phoneNumber
        cellNumber
        idImage
        businessLicense
        priceListInvites
        acceptedInvites
        userGroupID
        createdByUserId
        activeInvoiceID
        activePricelistID
        secondPricelistID
        companyLogo
        companyPath
        primaryColor
        secondaryColor
        searchesRemaining
        priceOffsetType
        priceOffsetValue
        providerOffsetType
        providerOffsetValue
        createdAt
        updatedAt
        themeOptions
        subscriptionActive
        lastPaidDate
        subscriptionTier
        subscriptionTerm
        isProvider
        lastLogin
        pricelistSubscribersId
        userGroupUsersId
        userInventoryId
        __typename
      }
      userId
      validRows
      dataCount
      s3Key
      notes
      filename
      adjustments
      name
      parts {
        nextToken
        __typename
      }
      status
      createdAt
      updatedAt
      __typename
    }
  }
`;
export const onDeleteSecondPricelist = /* GraphQL */ `
  subscription OnDeleteSecondPricelist(
    $filter: ModelSubscriptionSecondPricelistFilterInput
  ) {
    onDeleteSecondPricelist(filter: $filter) {
      id
      user {
        id
        username
        tier
        email
        address
        city
        state
        zip
        contactName
        companyName
        phoneNumber
        cellNumber
        idImage
        businessLicense
        priceListInvites
        acceptedInvites
        userGroupID
        createdByUserId
        activeInvoiceID
        activePricelistID
        secondPricelistID
        companyLogo
        companyPath
        primaryColor
        secondaryColor
        searchesRemaining
        priceOffsetType
        priceOffsetValue
        providerOffsetType
        providerOffsetValue
        createdAt
        updatedAt
        themeOptions
        subscriptionActive
        lastPaidDate
        subscriptionTier
        subscriptionTerm
        isProvider
        lastLogin
        pricelistSubscribersId
        userGroupUsersId
        userInventoryId
        __typename
      }
      userId
      validRows
      dataCount
      s3Key
      notes
      filename
      adjustments
      name
      parts {
        nextToken
        __typename
      }
      status
      createdAt
      updatedAt
      __typename
    }
  }
`;
export const onCreateCSVFile = /* GraphQL */ `
  subscription OnCreateCSVFile($filter: ModelSubscriptionCSVFileFilterInput) {
    onCreateCSVFile(filter: $filter) {
      id
      uploadedAt
      username
      validRows
      dataCount
      s3Key
      user {
        id
        username
        tier
        email
        address
        city
        state
        zip
        contactName
        companyName
        phoneNumber
        cellNumber
        idImage
        businessLicense
        priceListInvites
        acceptedInvites
        userGroupID
        createdByUserId
        activeInvoiceID
        activePricelistID
        secondPricelistID
        companyLogo
        companyPath
        primaryColor
        secondaryColor
        searchesRemaining
        priceOffsetType
        priceOffsetValue
        providerOffsetType
        providerOffsetValue
        createdAt
        updatedAt
        themeOptions
        subscriptionActive
        lastPaidDate
        subscriptionTier
        subscriptionTerm
        isProvider
        lastLogin
        pricelistSubscribersId
        userGroupUsersId
        userInventoryId
        __typename
      }
      createdAt
      updatedAt
      userCSVFilesId
      __typename
    }
  }
`;
export const onUpdateCSVFile = /* GraphQL */ `
  subscription OnUpdateCSVFile($filter: ModelSubscriptionCSVFileFilterInput) {
    onUpdateCSVFile(filter: $filter) {
      id
      uploadedAt
      username
      validRows
      dataCount
      s3Key
      user {
        id
        username
        tier
        email
        address
        city
        state
        zip
        contactName
        companyName
        phoneNumber
        cellNumber
        idImage
        businessLicense
        priceListInvites
        acceptedInvites
        userGroupID
        createdByUserId
        activeInvoiceID
        activePricelistID
        secondPricelistID
        companyLogo
        companyPath
        primaryColor
        secondaryColor
        searchesRemaining
        priceOffsetType
        priceOffsetValue
        providerOffsetType
        providerOffsetValue
        createdAt
        updatedAt
        themeOptions
        subscriptionActive
        lastPaidDate
        subscriptionTier
        subscriptionTerm
        isProvider
        lastLogin
        pricelistSubscribersId
        userGroupUsersId
        userInventoryId
        __typename
      }
      createdAt
      updatedAt
      userCSVFilesId
      __typename
    }
  }
`;
export const onDeleteCSVFile = /* GraphQL */ `
  subscription OnDeleteCSVFile($filter: ModelSubscriptionCSVFileFilterInput) {
    onDeleteCSVFile(filter: $filter) {
      id
      uploadedAt
      username
      validRows
      dataCount
      s3Key
      user {
        id
        username
        tier
        email
        address
        city
        state
        zip
        contactName
        companyName
        phoneNumber
        cellNumber
        idImage
        businessLicense
        priceListInvites
        acceptedInvites
        userGroupID
        createdByUserId
        activeInvoiceID
        activePricelistID
        secondPricelistID
        companyLogo
        companyPath
        primaryColor
        secondaryColor
        searchesRemaining
        priceOffsetType
        priceOffsetValue
        providerOffsetType
        providerOffsetValue
        createdAt
        updatedAt
        themeOptions
        subscriptionActive
        lastPaidDate
        subscriptionTier
        subscriptionTerm
        isProvider
        lastLogin
        pricelistSubscribersId
        userGroupUsersId
        userInventoryId
        __typename
      }
      createdAt
      updatedAt
      userCSVFilesId
      __typename
    }
  }
`;
export const onCreateSearch = /* GraphQL */ `
  subscription OnCreateSearch($filter: ModelSubscriptionSearchFilterInput) {
    onCreateSearch(filter: $filter) {
      id
      ipAddress
      location
      latitude
      longitude
      price
      partNumber
      userID
      user {
        id
        username
        tier
        email
        address
        city
        state
        zip
        contactName
        companyName
        phoneNumber
        cellNumber
        idImage
        businessLicense
        priceListInvites
        acceptedInvites
        userGroupID
        createdByUserId
        activeInvoiceID
        activePricelistID
        secondPricelistID
        companyLogo
        companyPath
        primaryColor
        secondaryColor
        searchesRemaining
        priceOffsetType
        priceOffsetValue
        providerOffsetType
        providerOffsetValue
        createdAt
        updatedAt
        themeOptions
        subscriptionActive
        lastPaidDate
        subscriptionTier
        subscriptionTerm
        isProvider
        lastLogin
        pricelistSubscribersId
        userGroupUsersId
        userInventoryId
        __typename
      }
      userSearched {
        id
        username
        tier
        email
        address
        city
        state
        zip
        contactName
        companyName
        phoneNumber
        cellNumber
        idImage
        businessLicense
        priceListInvites
        acceptedInvites
        userGroupID
        createdByUserId
        activeInvoiceID
        activePricelistID
        secondPricelistID
        companyLogo
        companyPath
        primaryColor
        secondaryColor
        searchesRemaining
        priceOffsetType
        priceOffsetValue
        providerOffsetType
        providerOffsetValue
        createdAt
        updatedAt
        themeOptions
        subscriptionActive
        lastPaidDate
        subscriptionTier
        subscriptionTerm
        isProvider
        lastLogin
        pricelistSubscribersId
        userGroupUsersId
        userInventoryId
        __typename
      }
      userSearchedID
      pricelistID
      pricelist {
        id
        userId
        validRows
        dataCount
        s3Key
        notes
        filename
        adjustments
        name
        status
        providerId
        createdAt
        updatedAt
        pricelistDerivedPricelistsId
        userPricelistsId
        __typename
      }
      createdAt
      updatedAt
      pricelistSearchesId
      userSearchesId
      __typename
    }
  }
`;
export const onUpdateSearch = /* GraphQL */ `
  subscription OnUpdateSearch($filter: ModelSubscriptionSearchFilterInput) {
    onUpdateSearch(filter: $filter) {
      id
      ipAddress
      location
      latitude
      longitude
      price
      partNumber
      userID
      user {
        id
        username
        tier
        email
        address
        city
        state
        zip
        contactName
        companyName
        phoneNumber
        cellNumber
        idImage
        businessLicense
        priceListInvites
        acceptedInvites
        userGroupID
        createdByUserId
        activeInvoiceID
        activePricelistID
        secondPricelistID
        companyLogo
        companyPath
        primaryColor
        secondaryColor
        searchesRemaining
        priceOffsetType
        priceOffsetValue
        providerOffsetType
        providerOffsetValue
        createdAt
        updatedAt
        themeOptions
        subscriptionActive
        lastPaidDate
        subscriptionTier
        subscriptionTerm
        isProvider
        lastLogin
        pricelistSubscribersId
        userGroupUsersId
        userInventoryId
        __typename
      }
      userSearched {
        id
        username
        tier
        email
        address
        city
        state
        zip
        contactName
        companyName
        phoneNumber
        cellNumber
        idImage
        businessLicense
        priceListInvites
        acceptedInvites
        userGroupID
        createdByUserId
        activeInvoiceID
        activePricelistID
        secondPricelistID
        companyLogo
        companyPath
        primaryColor
        secondaryColor
        searchesRemaining
        priceOffsetType
        priceOffsetValue
        providerOffsetType
        providerOffsetValue
        createdAt
        updatedAt
        themeOptions
        subscriptionActive
        lastPaidDate
        subscriptionTier
        subscriptionTerm
        isProvider
        lastLogin
        pricelistSubscribersId
        userGroupUsersId
        userInventoryId
        __typename
      }
      userSearchedID
      pricelistID
      pricelist {
        id
        userId
        validRows
        dataCount
        s3Key
        notes
        filename
        adjustments
        name
        status
        providerId
        createdAt
        updatedAt
        pricelistDerivedPricelistsId
        userPricelistsId
        __typename
      }
      createdAt
      updatedAt
      pricelistSearchesId
      userSearchesId
      __typename
    }
  }
`;
export const onDeleteSearch = /* GraphQL */ `
  subscription OnDeleteSearch($filter: ModelSubscriptionSearchFilterInput) {
    onDeleteSearch(filter: $filter) {
      id
      ipAddress
      location
      latitude
      longitude
      price
      partNumber
      userID
      user {
        id
        username
        tier
        email
        address
        city
        state
        zip
        contactName
        companyName
        phoneNumber
        cellNumber
        idImage
        businessLicense
        priceListInvites
        acceptedInvites
        userGroupID
        createdByUserId
        activeInvoiceID
        activePricelistID
        secondPricelistID
        companyLogo
        companyPath
        primaryColor
        secondaryColor
        searchesRemaining
        priceOffsetType
        priceOffsetValue
        providerOffsetType
        providerOffsetValue
        createdAt
        updatedAt
        themeOptions
        subscriptionActive
        lastPaidDate
        subscriptionTier
        subscriptionTerm
        isProvider
        lastLogin
        pricelistSubscribersId
        userGroupUsersId
        userInventoryId
        __typename
      }
      userSearched {
        id
        username
        tier
        email
        address
        city
        state
        zip
        contactName
        companyName
        phoneNumber
        cellNumber
        idImage
        businessLicense
        priceListInvites
        acceptedInvites
        userGroupID
        createdByUserId
        activeInvoiceID
        activePricelistID
        secondPricelistID
        companyLogo
        companyPath
        primaryColor
        secondaryColor
        searchesRemaining
        priceOffsetType
        priceOffsetValue
        providerOffsetType
        providerOffsetValue
        createdAt
        updatedAt
        themeOptions
        subscriptionActive
        lastPaidDate
        subscriptionTier
        subscriptionTerm
        isProvider
        lastLogin
        pricelistSubscribersId
        userGroupUsersId
        userInventoryId
        __typename
      }
      userSearchedID
      pricelistID
      pricelist {
        id
        userId
        validRows
        dataCount
        s3Key
        notes
        filename
        adjustments
        name
        status
        providerId
        createdAt
        updatedAt
        pricelistDerivedPricelistsId
        userPricelistsId
        __typename
      }
      createdAt
      updatedAt
      pricelistSearchesId
      userSearchesId
      __typename
    }
  }
`;
export const onCreateUser = /* GraphQL */ `
  subscription OnCreateUser($filter: ModelSubscriptionUserFilterInput) {
    onCreateUser(filter: $filter) {
      id
      username
      tier
      email
      searches {
        nextToken
        __typename
      }
      alerts {
        nextToken
        __typename
      }
      newsitems {
        nextToken
        __typename
      }
      inventory {
        id
        createdAt
        updatedAt
        inventoryUserId
        __typename
      }
      addedParts {
        nextToken
        __typename
      }
      address
      city
      state
      zip
      contactName
      companyName
      phoneNumber
      cellNumber
      idImage
      businessLicense
      priceListInvites
      acceptedInvites
      ownedInvoices {
        nextToken
        __typename
      }
      ownedUserGroups {
        nextToken
        __typename
      }
      userGroupID
      userGroup {
        id
        title
        content
        userID
        percentageAdjustment
        dollarAdjustment
        adjustmentType
        createdAt
        updatedAt
        userOwnedUserGroupsId
        __typename
      }
      CSVFiles {
        nextToken
        __typename
      }
      Pricelists {
        nextToken
        __typename
      }
      createdByUserId
      customers {
        nextToken
        __typename
      }
      activeInvoiceID
      activeInvoice {
        id
        dateSent
        ownerID
        recipientID
        invoiceNumber
        status
        name
        partCount
        createdAt
        updatedAt
        userOwnedInvoicesId
        __typename
      }
      activePricelistID
      activePricelist {
        id
        userId
        validRows
        dataCount
        s3Key
        notes
        filename
        adjustments
        name
        status
        providerId
        createdAt
        updatedAt
        pricelistDerivedPricelistsId
        userPricelistsId
        __typename
      }
      secondPricelistID
      secondPricelist {
        id
        userId
        validRows
        dataCount
        s3Key
        notes
        filename
        adjustments
        name
        status
        createdAt
        updatedAt
        __typename
      }
      companyLogo
      companyPath
      primaryColor
      secondaryColor
      supportTickets {
        nextToken
        __typename
      }
      searchesRemaining
      priceOffsetType
      priceOffsetValue
      providerOffsetType
      providerOffsetValue
      createdAt
      updatedAt
      themeOptions
      subscriptionActive
      lastPaidDate
      subscriptionTier
      subscriptionTerm
      isProvider
      lastLogin
      pricelistSubscribersId
      userGroupUsersId
      userInventoryId
      __typename
    }
  }
`;
export const onUpdateUser = /* GraphQL */ `
  subscription OnUpdateUser($filter: ModelSubscriptionUserFilterInput) {
    onUpdateUser(filter: $filter) {
      id
      username
      tier
      email
      searches {
        nextToken
        __typename
      }
      alerts {
        nextToken
        __typename
      }
      newsitems {
        nextToken
        __typename
      }
      inventory {
        id
        createdAt
        updatedAt
        inventoryUserId
        __typename
      }
      addedParts {
        nextToken
        __typename
      }
      address
      city
      state
      zip
      contactName
      companyName
      phoneNumber
      cellNumber
      idImage
      businessLicense
      priceListInvites
      acceptedInvites
      ownedInvoices {
        nextToken
        __typename
      }
      ownedUserGroups {
        nextToken
        __typename
      }
      userGroupID
      userGroup {
        id
        title
        content
        userID
        percentageAdjustment
        dollarAdjustment
        adjustmentType
        createdAt
        updatedAt
        userOwnedUserGroupsId
        __typename
      }
      CSVFiles {
        nextToken
        __typename
      }
      Pricelists {
        nextToken
        __typename
      }
      createdByUserId
      customers {
        nextToken
        __typename
      }
      activeInvoiceID
      activeInvoice {
        id
        dateSent
        ownerID
        recipientID
        invoiceNumber
        status
        name
        partCount
        createdAt
        updatedAt
        userOwnedInvoicesId
        __typename
      }
      activePricelistID
      activePricelist {
        id
        userId
        validRows
        dataCount
        s3Key
        notes
        filename
        adjustments
        name
        status
        providerId
        createdAt
        updatedAt
        pricelistDerivedPricelistsId
        userPricelistsId
        __typename
      }
      secondPricelistID
      secondPricelist {
        id
        userId
        validRows
        dataCount
        s3Key
        notes
        filename
        adjustments
        name
        status
        createdAt
        updatedAt
        __typename
      }
      companyLogo
      companyPath
      primaryColor
      secondaryColor
      supportTickets {
        nextToken
        __typename
      }
      searchesRemaining
      priceOffsetType
      priceOffsetValue
      providerOffsetType
      providerOffsetValue
      createdAt
      updatedAt
      themeOptions
      subscriptionActive
      lastPaidDate
      subscriptionTier
      subscriptionTerm
      isProvider
      lastLogin
      pricelistSubscribersId
      userGroupUsersId
      userInventoryId
      __typename
    }
  }
`;
export const onDeleteUser = /* GraphQL */ `
  subscription OnDeleteUser($filter: ModelSubscriptionUserFilterInput) {
    onDeleteUser(filter: $filter) {
      id
      username
      tier
      email
      searches {
        nextToken
        __typename
      }
      alerts {
        nextToken
        __typename
      }
      newsitems {
        nextToken
        __typename
      }
      inventory {
        id
        createdAt
        updatedAt
        inventoryUserId
        __typename
      }
      addedParts {
        nextToken
        __typename
      }
      address
      city
      state
      zip
      contactName
      companyName
      phoneNumber
      cellNumber
      idImage
      businessLicense
      priceListInvites
      acceptedInvites
      ownedInvoices {
        nextToken
        __typename
      }
      ownedUserGroups {
        nextToken
        __typename
      }
      userGroupID
      userGroup {
        id
        title
        content
        userID
        percentageAdjustment
        dollarAdjustment
        adjustmentType
        createdAt
        updatedAt
        userOwnedUserGroupsId
        __typename
      }
      CSVFiles {
        nextToken
        __typename
      }
      Pricelists {
        nextToken
        __typename
      }
      createdByUserId
      customers {
        nextToken
        __typename
      }
      activeInvoiceID
      activeInvoice {
        id
        dateSent
        ownerID
        recipientID
        invoiceNumber
        status
        name
        partCount
        createdAt
        updatedAt
        userOwnedInvoicesId
        __typename
      }
      activePricelistID
      activePricelist {
        id
        userId
        validRows
        dataCount
        s3Key
        notes
        filename
        adjustments
        name
        status
        providerId
        createdAt
        updatedAt
        pricelistDerivedPricelistsId
        userPricelistsId
        __typename
      }
      secondPricelistID
      secondPricelist {
        id
        userId
        validRows
        dataCount
        s3Key
        notes
        filename
        adjustments
        name
        status
        createdAt
        updatedAt
        __typename
      }
      companyLogo
      companyPath
      primaryColor
      secondaryColor
      supportTickets {
        nextToken
        __typename
      }
      searchesRemaining
      priceOffsetType
      priceOffsetValue
      providerOffsetType
      providerOffsetValue
      createdAt
      updatedAt
      themeOptions
      subscriptionActive
      lastPaidDate
      subscriptionTier
      subscriptionTerm
      isProvider
      lastLogin
      pricelistSubscribersId
      userGroupUsersId
      userInventoryId
      __typename
    }
  }
`;
export const onCreateUserGroup = /* GraphQL */ `
  subscription OnCreateUserGroup(
    $filter: ModelSubscriptionUserGroupFilterInput
  ) {
    onCreateUserGroup(filter: $filter) {
      id
      title
      content
      userID
      user {
        id
        username
        tier
        email
        address
        city
        state
        zip
        contactName
        companyName
        phoneNumber
        cellNumber
        idImage
        businessLicense
        priceListInvites
        acceptedInvites
        userGroupID
        createdByUserId
        activeInvoiceID
        activePricelistID
        secondPricelistID
        companyLogo
        companyPath
        primaryColor
        secondaryColor
        searchesRemaining
        priceOffsetType
        priceOffsetValue
        providerOffsetType
        providerOffsetValue
        createdAt
        updatedAt
        themeOptions
        subscriptionActive
        lastPaidDate
        subscriptionTier
        subscriptionTerm
        isProvider
        lastLogin
        pricelistSubscribersId
        userGroupUsersId
        userInventoryId
        __typename
      }
      users {
        nextToken
        __typename
      }
      percentageAdjustment
      dollarAdjustment
      adjustmentType
      createdAt
      updatedAt
      userOwnedUserGroupsId
      __typename
    }
  }
`;
export const onUpdateUserGroup = /* GraphQL */ `
  subscription OnUpdateUserGroup(
    $filter: ModelSubscriptionUserGroupFilterInput
  ) {
    onUpdateUserGroup(filter: $filter) {
      id
      title
      content
      userID
      user {
        id
        username
        tier
        email
        address
        city
        state
        zip
        contactName
        companyName
        phoneNumber
        cellNumber
        idImage
        businessLicense
        priceListInvites
        acceptedInvites
        userGroupID
        createdByUserId
        activeInvoiceID
        activePricelistID
        secondPricelistID
        companyLogo
        companyPath
        primaryColor
        secondaryColor
        searchesRemaining
        priceOffsetType
        priceOffsetValue
        providerOffsetType
        providerOffsetValue
        createdAt
        updatedAt
        themeOptions
        subscriptionActive
        lastPaidDate
        subscriptionTier
        subscriptionTerm
        isProvider
        lastLogin
        pricelistSubscribersId
        userGroupUsersId
        userInventoryId
        __typename
      }
      users {
        nextToken
        __typename
      }
      percentageAdjustment
      dollarAdjustment
      adjustmentType
      createdAt
      updatedAt
      userOwnedUserGroupsId
      __typename
    }
  }
`;
export const onDeleteUserGroup = /* GraphQL */ `
  subscription OnDeleteUserGroup(
    $filter: ModelSubscriptionUserGroupFilterInput
  ) {
    onDeleteUserGroup(filter: $filter) {
      id
      title
      content
      userID
      user {
        id
        username
        tier
        email
        address
        city
        state
        zip
        contactName
        companyName
        phoneNumber
        cellNumber
        idImage
        businessLicense
        priceListInvites
        acceptedInvites
        userGroupID
        createdByUserId
        activeInvoiceID
        activePricelistID
        secondPricelistID
        companyLogo
        companyPath
        primaryColor
        secondaryColor
        searchesRemaining
        priceOffsetType
        priceOffsetValue
        providerOffsetType
        providerOffsetValue
        createdAt
        updatedAt
        themeOptions
        subscriptionActive
        lastPaidDate
        subscriptionTier
        subscriptionTerm
        isProvider
        lastLogin
        pricelistSubscribersId
        userGroupUsersId
        userInventoryId
        __typename
      }
      users {
        nextToken
        __typename
      }
      percentageAdjustment
      dollarAdjustment
      adjustmentType
      createdAt
      updatedAt
      userOwnedUserGroupsId
      __typename
    }
  }
`;
export const onCreateAlert = /* GraphQL */ `
  subscription OnCreateAlert($filter: ModelSubscriptionAlertFilterInput) {
    onCreateAlert(filter: $filter) {
      id
      title
      content
      userID
      user {
        id
        username
        tier
        email
        address
        city
        state
        zip
        contactName
        companyName
        phoneNumber
        cellNumber
        idImage
        businessLicense
        priceListInvites
        acceptedInvites
        userGroupID
        createdByUserId
        activeInvoiceID
        activePricelistID
        secondPricelistID
        companyLogo
        companyPath
        primaryColor
        secondaryColor
        searchesRemaining
        priceOffsetType
        priceOffsetValue
        providerOffsetType
        providerOffsetValue
        createdAt
        updatedAt
        themeOptions
        subscriptionActive
        lastPaidDate
        subscriptionTier
        subscriptionTerm
        isProvider
        lastLogin
        pricelistSubscribersId
        userGroupUsersId
        userInventoryId
        __typename
      }
      read
      createdAt
      isAdminNotification
      updatedAt
      userAlertsId
      __typename
    }
  }
`;
export const onUpdateAlert = /* GraphQL */ `
  subscription OnUpdateAlert($filter: ModelSubscriptionAlertFilterInput) {
    onUpdateAlert(filter: $filter) {
      id
      title
      content
      userID
      user {
        id
        username
        tier
        email
        address
        city
        state
        zip
        contactName
        companyName
        phoneNumber
        cellNumber
        idImage
        businessLicense
        priceListInvites
        acceptedInvites
        userGroupID
        createdByUserId
        activeInvoiceID
        activePricelistID
        secondPricelistID
        companyLogo
        companyPath
        primaryColor
        secondaryColor
        searchesRemaining
        priceOffsetType
        priceOffsetValue
        providerOffsetType
        providerOffsetValue
        createdAt
        updatedAt
        themeOptions
        subscriptionActive
        lastPaidDate
        subscriptionTier
        subscriptionTerm
        isProvider
        lastLogin
        pricelistSubscribersId
        userGroupUsersId
        userInventoryId
        __typename
      }
      read
      createdAt
      isAdminNotification
      updatedAt
      userAlertsId
      __typename
    }
  }
`;
export const onDeleteAlert = /* GraphQL */ `
  subscription OnDeleteAlert($filter: ModelSubscriptionAlertFilterInput) {
    onDeleteAlert(filter: $filter) {
      id
      title
      content
      userID
      user {
        id
        username
        tier
        email
        address
        city
        state
        zip
        contactName
        companyName
        phoneNumber
        cellNumber
        idImage
        businessLicense
        priceListInvites
        acceptedInvites
        userGroupID
        createdByUserId
        activeInvoiceID
        activePricelistID
        secondPricelistID
        companyLogo
        companyPath
        primaryColor
        secondaryColor
        searchesRemaining
        priceOffsetType
        priceOffsetValue
        providerOffsetType
        providerOffsetValue
        createdAt
        updatedAt
        themeOptions
        subscriptionActive
        lastPaidDate
        subscriptionTier
        subscriptionTerm
        isProvider
        lastLogin
        pricelistSubscribersId
        userGroupUsersId
        userInventoryId
        __typename
      }
      read
      createdAt
      isAdminNotification
      updatedAt
      userAlertsId
      __typename
    }
  }
`;
export const onCreateNewsItem = /* GraphQL */ `
  subscription OnCreateNewsItem($filter: ModelSubscriptionNewsItemFilterInput) {
    onCreateNewsItem(filter: $filter) {
      id
      title
      content
      img
      user {
        id
        username
        tier
        email
        address
        city
        state
        zip
        contactName
        companyName
        phoneNumber
        cellNumber
        idImage
        businessLicense
        priceListInvites
        acceptedInvites
        userGroupID
        createdByUserId
        activeInvoiceID
        activePricelistID
        secondPricelistID
        companyLogo
        companyPath
        primaryColor
        secondaryColor
        searchesRemaining
        priceOffsetType
        priceOffsetValue
        providerOffsetType
        providerOffsetValue
        createdAt
        updatedAt
        themeOptions
        subscriptionActive
        lastPaidDate
        subscriptionTier
        subscriptionTerm
        isProvider
        lastLogin
        pricelistSubscribersId
        userGroupUsersId
        userInventoryId
        __typename
      }
      createdAt
      updatedAt
      userNewsitemsId
      __typename
    }
  }
`;
export const onUpdateNewsItem = /* GraphQL */ `
  subscription OnUpdateNewsItem($filter: ModelSubscriptionNewsItemFilterInput) {
    onUpdateNewsItem(filter: $filter) {
      id
      title
      content
      img
      user {
        id
        username
        tier
        email
        address
        city
        state
        zip
        contactName
        companyName
        phoneNumber
        cellNumber
        idImage
        businessLicense
        priceListInvites
        acceptedInvites
        userGroupID
        createdByUserId
        activeInvoiceID
        activePricelistID
        secondPricelistID
        companyLogo
        companyPath
        primaryColor
        secondaryColor
        searchesRemaining
        priceOffsetType
        priceOffsetValue
        providerOffsetType
        providerOffsetValue
        createdAt
        updatedAt
        themeOptions
        subscriptionActive
        lastPaidDate
        subscriptionTier
        subscriptionTerm
        isProvider
        lastLogin
        pricelistSubscribersId
        userGroupUsersId
        userInventoryId
        __typename
      }
      createdAt
      updatedAt
      userNewsitemsId
      __typename
    }
  }
`;
export const onDeleteNewsItem = /* GraphQL */ `
  subscription OnDeleteNewsItem($filter: ModelSubscriptionNewsItemFilterInput) {
    onDeleteNewsItem(filter: $filter) {
      id
      title
      content
      img
      user {
        id
        username
        tier
        email
        address
        city
        state
        zip
        contactName
        companyName
        phoneNumber
        cellNumber
        idImage
        businessLicense
        priceListInvites
        acceptedInvites
        userGroupID
        createdByUserId
        activeInvoiceID
        activePricelistID
        secondPricelistID
        companyLogo
        companyPath
        primaryColor
        secondaryColor
        searchesRemaining
        priceOffsetType
        priceOffsetValue
        providerOffsetType
        providerOffsetValue
        createdAt
        updatedAt
        themeOptions
        subscriptionActive
        lastPaidDate
        subscriptionTier
        subscriptionTerm
        isProvider
        lastLogin
        pricelistSubscribersId
        userGroupUsersId
        userInventoryId
        __typename
      }
      createdAt
      updatedAt
      userNewsitemsId
      __typename
    }
  }
`;
export const onCreateInventory = /* GraphQL */ `
  subscription OnCreateInventory(
    $filter: ModelSubscriptionInventoryFilterInput
  ) {
    onCreateInventory(filter: $filter) {
      id
      user {
        id
        username
        tier
        email
        address
        city
        state
        zip
        contactName
        companyName
        phoneNumber
        cellNumber
        idImage
        businessLicense
        priceListInvites
        acceptedInvites
        userGroupID
        createdByUserId
        activeInvoiceID
        activePricelistID
        secondPricelistID
        companyLogo
        companyPath
        primaryColor
        secondaryColor
        searchesRemaining
        priceOffsetType
        priceOffsetValue
        providerOffsetType
        providerOffsetValue
        createdAt
        updatedAt
        themeOptions
        subscriptionActive
        lastPaidDate
        subscriptionTier
        subscriptionTerm
        isProvider
        lastLogin
        pricelistSubscribersId
        userGroupUsersId
        userInventoryId
        __typename
      }
      boxes {
        nextToken
        __typename
      }
      createdAt
      updatedAt
      inventoryUserId
      __typename
    }
  }
`;
export const onUpdateInventory = /* GraphQL */ `
  subscription OnUpdateInventory(
    $filter: ModelSubscriptionInventoryFilterInput
  ) {
    onUpdateInventory(filter: $filter) {
      id
      user {
        id
        username
        tier
        email
        address
        city
        state
        zip
        contactName
        companyName
        phoneNumber
        cellNumber
        idImage
        businessLicense
        priceListInvites
        acceptedInvites
        userGroupID
        createdByUserId
        activeInvoiceID
        activePricelistID
        secondPricelistID
        companyLogo
        companyPath
        primaryColor
        secondaryColor
        searchesRemaining
        priceOffsetType
        priceOffsetValue
        providerOffsetType
        providerOffsetValue
        createdAt
        updatedAt
        themeOptions
        subscriptionActive
        lastPaidDate
        subscriptionTier
        subscriptionTerm
        isProvider
        lastLogin
        pricelistSubscribersId
        userGroupUsersId
        userInventoryId
        __typename
      }
      boxes {
        nextToken
        __typename
      }
      createdAt
      updatedAt
      inventoryUserId
      __typename
    }
  }
`;
export const onDeleteInventory = /* GraphQL */ `
  subscription OnDeleteInventory(
    $filter: ModelSubscriptionInventoryFilterInput
  ) {
    onDeleteInventory(filter: $filter) {
      id
      user {
        id
        username
        tier
        email
        address
        city
        state
        zip
        contactName
        companyName
        phoneNumber
        cellNumber
        idImage
        businessLicense
        priceListInvites
        acceptedInvites
        userGroupID
        createdByUserId
        activeInvoiceID
        activePricelistID
        secondPricelistID
        companyLogo
        companyPath
        primaryColor
        secondaryColor
        searchesRemaining
        priceOffsetType
        priceOffsetValue
        providerOffsetType
        providerOffsetValue
        createdAt
        updatedAt
        themeOptions
        subscriptionActive
        lastPaidDate
        subscriptionTier
        subscriptionTerm
        isProvider
        lastLogin
        pricelistSubscribersId
        userGroupUsersId
        userInventoryId
        __typename
      }
      boxes {
        nextToken
        __typename
      }
      createdAt
      updatedAt
      inventoryUserId
      __typename
    }
  }
`;
export const onCreatePart = /* GraphQL */ `
  subscription OnCreatePart($filter: ModelSubscriptionPartFilterInput) {
    onCreatePart(filter: $filter) {
      id
      partNumber
      secondPartNumber
      price
      addedByUser
      fromPricelist
      status
      cost
      grade
      createdAt
      updatedAt
      pricelistPartsId
      secondPricelistPartsId
      userAddedPartsId
      boxPartsId
      invoicePartsId
      __typename
    }
  }
`;
export const onUpdatePart = /* GraphQL */ `
  subscription OnUpdatePart($filter: ModelSubscriptionPartFilterInput) {
    onUpdatePart(filter: $filter) {
      id
      partNumber
      secondPartNumber
      price
      addedByUser
      fromPricelist
      status
      cost
      grade
      createdAt
      updatedAt
      pricelistPartsId
      secondPricelistPartsId
      userAddedPartsId
      boxPartsId
      invoicePartsId
      __typename
    }
  }
`;
export const onDeletePart = /* GraphQL */ `
  subscription OnDeletePart($filter: ModelSubscriptionPartFilterInput) {
    onDeletePart(filter: $filter) {
      id
      partNumber
      secondPartNumber
      price
      addedByUser
      fromPricelist
      status
      cost
      grade
      createdAt
      updatedAt
      pricelistPartsId
      secondPricelistPartsId
      userAddedPartsId
      boxPartsId
      invoicePartsId
      __typename
    }
  }
`;
export const onCreateBox = /* GraphQL */ `
  subscription OnCreateBox($filter: ModelSubscriptionBoxFilterInput) {
    onCreateBox(filter: $filter) {
      id
      name
      parts {
        nextToken
        __typename
      }
      inventory {
        id
        createdAt
        updatedAt
        inventoryUserId
        __typename
      }
      invoice {
        id
        dateSent
        ownerID
        recipientID
        invoiceNumber
        status
        name
        partCount
        createdAt
        updatedAt
        userOwnedInvoicesId
        __typename
      }
      fromPricelist
      status
      createdAt
      updatedAt
      inventoryBoxesId
      invoiceBoxesId
      __typename
    }
  }
`;
export const onUpdateBox = /* GraphQL */ `
  subscription OnUpdateBox($filter: ModelSubscriptionBoxFilterInput) {
    onUpdateBox(filter: $filter) {
      id
      name
      parts {
        nextToken
        __typename
      }
      inventory {
        id
        createdAt
        updatedAt
        inventoryUserId
        __typename
      }
      invoice {
        id
        dateSent
        ownerID
        recipientID
        invoiceNumber
        status
        name
        partCount
        createdAt
        updatedAt
        userOwnedInvoicesId
        __typename
      }
      fromPricelist
      status
      createdAt
      updatedAt
      inventoryBoxesId
      invoiceBoxesId
      __typename
    }
  }
`;
export const onDeleteBox = /* GraphQL */ `
  subscription OnDeleteBox($filter: ModelSubscriptionBoxFilterInput) {
    onDeleteBox(filter: $filter) {
      id
      name
      parts {
        nextToken
        __typename
      }
      inventory {
        id
        createdAt
        updatedAt
        inventoryUserId
        __typename
      }
      invoice {
        id
        dateSent
        ownerID
        recipientID
        invoiceNumber
        status
        name
        partCount
        createdAt
        updatedAt
        userOwnedInvoicesId
        __typename
      }
      fromPricelist
      status
      createdAt
      updatedAt
      inventoryBoxesId
      invoiceBoxesId
      __typename
    }
  }
`;
export const onCreateInvoice = /* GraphQL */ `
  subscription OnCreateInvoice($filter: ModelSubscriptionInvoiceFilterInput) {
    onCreateInvoice(filter: $filter) {
      id
      boxes {
        nextToken
        __typename
      }
      dateSent
      owner {
        id
        username
        tier
        email
        address
        city
        state
        zip
        contactName
        companyName
        phoneNumber
        cellNumber
        idImage
        businessLicense
        priceListInvites
        acceptedInvites
        userGroupID
        createdByUserId
        activeInvoiceID
        activePricelistID
        secondPricelistID
        companyLogo
        companyPath
        primaryColor
        secondaryColor
        searchesRemaining
        priceOffsetType
        priceOffsetValue
        providerOffsetType
        providerOffsetValue
        createdAt
        updatedAt
        themeOptions
        subscriptionActive
        lastPaidDate
        subscriptionTier
        subscriptionTerm
        isProvider
        lastLogin
        pricelistSubscribersId
        userGroupUsersId
        userInventoryId
        __typename
      }
      ownerID
      recipientID
      recipient {
        id
        username
        tier
        email
        address
        city
        state
        zip
        contactName
        companyName
        phoneNumber
        cellNumber
        idImage
        businessLicense
        priceListInvites
        acceptedInvites
        userGroupID
        createdByUserId
        activeInvoiceID
        activePricelistID
        secondPricelistID
        companyLogo
        companyPath
        primaryColor
        secondaryColor
        searchesRemaining
        priceOffsetType
        priceOffsetValue
        providerOffsetType
        providerOffsetValue
        createdAt
        updatedAt
        themeOptions
        subscriptionActive
        lastPaidDate
        subscriptionTier
        subscriptionTerm
        isProvider
        lastLogin
        pricelistSubscribersId
        userGroupUsersId
        userInventoryId
        __typename
      }
      invoiceNumber
      status
      name
      parts {
        nextToken
        __typename
      }
      partCount
      createdAt
      updatedAt
      userOwnedInvoicesId
      __typename
    }
  }
`;
export const onUpdateInvoice = /* GraphQL */ `
  subscription OnUpdateInvoice($filter: ModelSubscriptionInvoiceFilterInput) {
    onUpdateInvoice(filter: $filter) {
      id
      boxes {
        nextToken
        __typename
      }
      dateSent
      owner {
        id
        username
        tier
        email
        address
        city
        state
        zip
        contactName
        companyName
        phoneNumber
        cellNumber
        idImage
        businessLicense
        priceListInvites
        acceptedInvites
        userGroupID
        createdByUserId
        activeInvoiceID
        activePricelistID
        secondPricelistID
        companyLogo
        companyPath
        primaryColor
        secondaryColor
        searchesRemaining
        priceOffsetType
        priceOffsetValue
        providerOffsetType
        providerOffsetValue
        createdAt
        updatedAt
        themeOptions
        subscriptionActive
        lastPaidDate
        subscriptionTier
        subscriptionTerm
        isProvider
        lastLogin
        pricelistSubscribersId
        userGroupUsersId
        userInventoryId
        __typename
      }
      ownerID
      recipientID
      recipient {
        id
        username
        tier
        email
        address
        city
        state
        zip
        contactName
        companyName
        phoneNumber
        cellNumber
        idImage
        businessLicense
        priceListInvites
        acceptedInvites
        userGroupID
        createdByUserId
        activeInvoiceID
        activePricelistID
        secondPricelistID
        companyLogo
        companyPath
        primaryColor
        secondaryColor
        searchesRemaining
        priceOffsetType
        priceOffsetValue
        providerOffsetType
        providerOffsetValue
        createdAt
        updatedAt
        themeOptions
        subscriptionActive
        lastPaidDate
        subscriptionTier
        subscriptionTerm
        isProvider
        lastLogin
        pricelistSubscribersId
        userGroupUsersId
        userInventoryId
        __typename
      }
      invoiceNumber
      status
      name
      parts {
        nextToken
        __typename
      }
      partCount
      createdAt
      updatedAt
      userOwnedInvoicesId
      __typename
    }
  }
`;
export const onDeleteInvoice = /* GraphQL */ `
  subscription OnDeleteInvoice($filter: ModelSubscriptionInvoiceFilterInput) {
    onDeleteInvoice(filter: $filter) {
      id
      boxes {
        nextToken
        __typename
      }
      dateSent
      owner {
        id
        username
        tier
        email
        address
        city
        state
        zip
        contactName
        companyName
        phoneNumber
        cellNumber
        idImage
        businessLicense
        priceListInvites
        acceptedInvites
        userGroupID
        createdByUserId
        activeInvoiceID
        activePricelistID
        secondPricelistID
        companyLogo
        companyPath
        primaryColor
        secondaryColor
        searchesRemaining
        priceOffsetType
        priceOffsetValue
        providerOffsetType
        providerOffsetValue
        createdAt
        updatedAt
        themeOptions
        subscriptionActive
        lastPaidDate
        subscriptionTier
        subscriptionTerm
        isProvider
        lastLogin
        pricelistSubscribersId
        userGroupUsersId
        userInventoryId
        __typename
      }
      ownerID
      recipientID
      recipient {
        id
        username
        tier
        email
        address
        city
        state
        zip
        contactName
        companyName
        phoneNumber
        cellNumber
        idImage
        businessLicense
        priceListInvites
        acceptedInvites
        userGroupID
        createdByUserId
        activeInvoiceID
        activePricelistID
        secondPricelistID
        companyLogo
        companyPath
        primaryColor
        secondaryColor
        searchesRemaining
        priceOffsetType
        priceOffsetValue
        providerOffsetType
        providerOffsetValue
        createdAt
        updatedAt
        themeOptions
        subscriptionActive
        lastPaidDate
        subscriptionTier
        subscriptionTerm
        isProvider
        lastLogin
        pricelistSubscribersId
        userGroupUsersId
        userInventoryId
        __typename
      }
      invoiceNumber
      status
      name
      parts {
        nextToken
        __typename
      }
      partCount
      createdAt
      updatedAt
      userOwnedInvoicesId
      __typename
    }
  }
`;
export const onCreateHedge = /* GraphQL */ `
  subscription OnCreateHedge($filter: ModelSubscriptionHedgeFilterInput) {
    onCreateHedge(filter: $filter) {
      id
      numberOfPieces
      status
      pricelist {
        id
        userId
        validRows
        dataCount
        s3Key
        notes
        filename
        adjustments
        name
        status
        providerId
        createdAt
        updatedAt
        pricelistDerivedPricelistsId
        userPricelistsId
        __typename
      }
      pricelistId
      createdAt
      updatedAt
      pricelistHedgesId
      __typename
    }
  }
`;
export const onUpdateHedge = /* GraphQL */ `
  subscription OnUpdateHedge($filter: ModelSubscriptionHedgeFilterInput) {
    onUpdateHedge(filter: $filter) {
      id
      numberOfPieces
      status
      pricelist {
        id
        userId
        validRows
        dataCount
        s3Key
        notes
        filename
        adjustments
        name
        status
        providerId
        createdAt
        updatedAt
        pricelistDerivedPricelistsId
        userPricelistsId
        __typename
      }
      pricelistId
      createdAt
      updatedAt
      pricelistHedgesId
      __typename
    }
  }
`;
export const onDeleteHedge = /* GraphQL */ `
  subscription OnDeleteHedge($filter: ModelSubscriptionHedgeFilterInput) {
    onDeleteHedge(filter: $filter) {
      id
      numberOfPieces
      status
      pricelist {
        id
        userId
        validRows
        dataCount
        s3Key
        notes
        filename
        adjustments
        name
        status
        providerId
        createdAt
        updatedAt
        pricelistDerivedPricelistsId
        userPricelistsId
        __typename
      }
      pricelistId
      createdAt
      updatedAt
      pricelistHedgesId
      __typename
    }
  }
`;
export const onCreateMappedVIN = /* GraphQL */ `
  subscription OnCreateMappedVIN(
    $filter: ModelSubscriptionMappedVINFilterInput
  ) {
    onCreateMappedVIN(filter: $filter) {
      id
      s3Key
      uploadDate
      recordCount
      createdAt
      updatedAt
      __typename
    }
  }
`;
export const onUpdateMappedVIN = /* GraphQL */ `
  subscription OnUpdateMappedVIN(
    $filter: ModelSubscriptionMappedVINFilterInput
  ) {
    onUpdateMappedVIN(filter: $filter) {
      id
      s3Key
      uploadDate
      recordCount
      createdAt
      updatedAt
      __typename
    }
  }
`;
export const onDeleteMappedVIN = /* GraphQL */ `
  subscription OnDeleteMappedVIN(
    $filter: ModelSubscriptionMappedVINFilterInput
  ) {
    onDeleteMappedVIN(filter: $filter) {
      id
      s3Key
      uploadDate
      recordCount
      createdAt
      updatedAt
      __typename
    }
  }
`;
export const onCreateSupportTicket = /* GraphQL */ `
  subscription OnCreateSupportTicket(
    $filter: ModelSubscriptionSupportTicketFilterInput
  ) {
    onCreateSupportTicket(filter: $filter) {
      id
      subject
      message
      ticketType
      createdAt
      updatedAt
      userSupportTicketsId
      __typename
    }
  }
`;
export const onUpdateSupportTicket = /* GraphQL */ `
  subscription OnUpdateSupportTicket(
    $filter: ModelSubscriptionSupportTicketFilterInput
  ) {
    onUpdateSupportTicket(filter: $filter) {
      id
      subject
      message
      ticketType
      createdAt
      updatedAt
      userSupportTicketsId
      __typename
    }
  }
`;
export const onDeleteSupportTicket = /* GraphQL */ `
  subscription OnDeleteSupportTicket(
    $filter: ModelSubscriptionSupportTicketFilterInput
  ) {
    onDeleteSupportTicket(filter: $filter) {
      id
      subject
      message
      ticketType
      createdAt
      updatedAt
      userSupportTicketsId
      __typename
    }
  }
`;
export const onCreateMetalPrice = /* GraphQL */ `
  subscription OnCreateMetalPrice(
    $filter: ModelSubscriptionMetalPriceFilterInput
  ) {
    onCreateMetalPrice(filter: $filter) {
      id
      metal
      price
      timestamp
      recordType
      createdAt
      updatedAt
      __typename
    }
  }
`;
export const onUpdateMetalPrice = /* GraphQL */ `
  subscription OnUpdateMetalPrice(
    $filter: ModelSubscriptionMetalPriceFilterInput
  ) {
    onUpdateMetalPrice(filter: $filter) {
      id
      metal
      price
      timestamp
      recordType
      createdAt
      updatedAt
      __typename
    }
  }
`;
export const onDeleteMetalPrice = /* GraphQL */ `
  subscription OnDeleteMetalPrice(
    $filter: ModelSubscriptionMetalPriceFilterInput
  ) {
    onDeleteMetalPrice(filter: $filter) {
      id
      metal
      price
      timestamp
      recordType
      createdAt
      updatedAt
      __typename
    }
  }
`;
